import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface WebhookDialogProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (data: { url: string; name: string }) => void;
}

const WebhookDialog = ({ open, onClose, onSubmit }: WebhookDialogProps) => {
    const { t } = useTranslation();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: {
            url: '',
            name: '',
        },
    });

    const handleFormSubmit = async (data: { url: string; name: string }) => {
        await onSubmit(data);
        reset();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <div>
                    <div className="text-2xl font-medium">{t('create_webhook')}</div>
                    <div className="text-sm text-gray-500">{t('create_webhook_description')}</div>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="mt-6 space-y-3">
                    <h2 className="text-lg font-medium">{t('webhook_url')}</h2>
                    <p className="text-sm text-gray-500">{t('webhook_url_description')}</p>
                    <TextField
                        size="small"
                        fullWidth
                        label={t('webhook_url')}
                        placeholder={t('webhook_url_placeholder')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        {...register('url', {
                            required: t('webhook_url_required'),
                        })}
                        error={!!errors.url}
                        helperText={errors.url?.message}
                    />
                </div>
                <div className="mt-6 space-y-3">
                    <h2 className="text-lg font-medium">{t('channel_name')}</h2>
                    <p className="text-sm text-gray-500">{t('channel_name_description')}</p>
                    <TextField
                        size="small"
                        fullWidth
                        label={t('channel_name')}
                        placeholder={t('channel_name_placeholder')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        {...register('name', {
                            required: t('channel_name_required'),
                        })}
                        error={!!errors.name}
                        helperText={errors.name?.message}
                    />
                </div>
            </DialogContent>
            <DialogActions className="mt-10">
                <Button onClick={onClose}>{t('cancel')}</Button>
                <Button onClick={handleSubmit(handleFormSubmit)} variant="contained" color="primary">
                    {t('save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WebhookDialog;
